var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "ghost-" + _vm.pos, appear: "" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.currentSidebar && _vm.available && _vm.side === _vm.pos,
            expression: "currentSidebar && available && side === pos",
          },
        ],
        staticClass: "sidebar col-11 col-lg-4",
        class: _vm.pos,
      },
      [
        _vm._t("close-button", function () {
          return [
            _c("w-btn-close", {
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.closeSidebar.apply(null, arguments)
                },
              },
            }),
          ]
        }),
        _vm._t("default", function () {
          return [
            _c("div", { key: _vm.name, staticClass: "sidebar-container" }, [
              _c(
                "div",
                {
                  directives: [{ name: "bar", rawName: "v-bar" }],
                  staticClass: "sidebar-scroller",
                },
                [
                  _c(
                    "div",
                    { staticClass: "sidebar-inner" },
                    [
                      _c(
                        _vm.name,
                        _vm._b(
                          { tag: "component" },
                          "component",
                          _vm.sidebarData,
                          false
                        )
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }